<template>
  <div class="cardswipe flex">
    <div class="prev center" @click="prev">
      <svg-icon icon-class="jt_right" class="flip180"></svg-icon>
    </div>
    <div class="next center" @click="next">
      <svg-icon icon-class="jt_right"></svg-icon>
    </div>
    <div class="leftimg"  @click="prev">
      <img :src="swipelist[leftact].img" alt="" />
    </div>
    <el-carousel
      class="tempswi"
      ref="tempswi"
      indicator-position="none"
      arrow="never"
      :interval="55000"
      @change="chaswi"
      height="420px"
    >
      <el-carousel-item v-for="(item, index) in swipelist" :key="index">
        <div class="tempitem text_center">
          <div class="cove">
            <img :src="item.img" alt="" />
          </div>
          <div class="name">{{ item.name }}</div>
          <div class="zhiye">{{ item.zhiye }}</div>
          <div class="jy">{{ item.jy }}</div>
          <div class="info">
            {{ item.info }}
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="rightimg" @click="next">
      <img :src="swipelist[rightact].img" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiact: 0,
      leftact: 0,
      rightact: 0,
      swipelist: [
        {
          name: "XX律师",
          zhiye: "天津君申律师事务所/主任律师",
          jy: "10年执业经验",
          info:
            "已办理各类诉讼案件600余件，承办法律援助案件近200件，服务政府部门、企事业单位20余家，为债权债务类当事人追回案款上千万元，为人身损害类当事人追索赔偿上百万元。曾荣获北京盈科（成都）律师事务所颁发“2019年度公益律师奖”、“2020年度优秀公益律师奖”、“2020年度优秀党员律师奖”，荣获成都市锦江区司法局颁发“2019年度法律援助案例二等奖”。",
          img: require("assets/base/photo-zhouzhe.png"),
        },
        {
          name: "XX律师",
          zhiye: "天津君申律师事务所/主任律师",
          jy: "10年执业经验",
          info:
            "已办理各类诉讼案件600余件，承办法律援助案件近200件，服务政府部门、企事业单位20余家，为债权债务类当事人追回案款上千万元，为人身损害类当事人追索赔偿上百万元。曾荣获北京盈科（成都）律师事务所颁发“2019年度公益律师奖”、“2020年度优秀公益律师奖”、“2020年度优秀党员律师奖”，荣获成都市锦江区司法局颁发“2019年度法律援助案例二等奖”。",
          img: require("assets/base/photo-shixigang.png"),
        },
        {
          name: "XX律师",
          zhiye: "天津君申律师事务所/主任律师",
          jy: "10年执业经验",
          info:
            "已办理各类诉讼案件600余件，承办法律援助案件近200件，服务政府部门、企事业单位20余家，为债权债务类当事人追回案款上千万元，为人身损害类当事人追索赔偿上百万元。曾荣获北京盈科（成都）律师事务所颁发“2019年度公益律师奖”、“2020年度优秀公益律师奖”、“2020年度优秀党员律师奖”，荣获成都市锦江区司法局颁发“2019年度法律援助案例二等奖”。",
          img: require("assets/base/photo-zhouzhe.png"),
        },
        {
          name: "XX律师",
          zhiye: "天津君申律师事务所/主任律师",
          jy: "10年执业经验",
          info:
            "已办理各类诉讼案件600余件，承办法律援助案件近200件，服务政府部门、企事业单位20余家，为债权债务类当事人追回案款上千万元，为人身损害类当事人追索赔偿上百万元。曾荣获北京盈科（成都）律师事务所颁发“2019年度公益律师奖”、“2020年度优秀公益律师奖”、“2020年度优秀党员律师奖”，荣获成都市锦江区司法局颁发“2019年度法律援助案例二等奖”。",
          img: require("assets/base/photo-shixigang.png"),
        },
        {
          name: "XX律师",
          zhiye: "天津君申律师事务所/主任律师",
          jy: "10年执业经验",
          info:
            "已办理各类诉讼案件600余件，承办法律援助案件近200件，服务政府部门、企事业单位20余家，为债权债务类当事人追回案款上千万元，为人身损害类当事人追索赔偿上百万元。曾荣获北京盈科（成都）律师事务所颁发“2019年度公益律师奖”、“2020年度优秀公益律师奖”、“2020年度优秀党员律师奖”，荣获成都市锦江区司法局颁发“2019年度法律援助案例二等奖”。",
          img: require("assets/base/photo-zhouzhe.png"),
        },
      ],
    };
  },
  mounted() {
    this.calcsort();
  },
  methods: {
    chaswi(e) {
      this.swiact = e;
      this.calcsort();
    },
    prev() {
      this.$refs.tempswi.prev();
    },
    next() {
      this.$refs.tempswi.next();
    },
    calcsort() {
      if (this.swiact == 0) {
        this.leftact = this.swipelist.length - 1;
        this.rightact = this.swiact++;
      } else {
        this.leftact = this.swiact--;
        this.rightact = this.swiact++;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cardswipe {
  position: relative;
  .tempswi {
    width: 800px;
    .tempitem {
    border-radius: 4px;
      height: 350px;
      margin-top: 65px;
      padding: 80px 28px 0;
      position: relative;
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.05);
      .cove {
        position: absolute;
        top: -62px;
        left: 50%;
        transform: translateX(-50%);
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        img {
          width: 115px;
          height: 115px;
          border-radius: 50%;
        }
      }
      .name {
        font-size: 22px;
        color: #333333;
      }
      .zhiye {
        margin-top: 10px;
        font-size: 18px;
        color: #666666;
      }
      .jy {
        margin-top: 10px;
        font-size: 16px;
        color: #0465ea;
      }
      .info {
        margin-top: 10px;
        text-align: left;
        font-size: 14px;
        color: #666666;
        line-height: 30px;
      }
    }
  }
  .leftimg,
  .rightimg {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-top: 110px;
    img {
      width: 210px;
      height: auto;
    }
  }
  .prev,
  .next {
    position: absolute;
    top: 50%;
    width: 43px;
    height: 43px;
    z-index: 10;
    border: 1px solid #e2e2e2;
    background-color: #e2e2e2;
    color: #fff;
    border-radius: 50%;
    &:hover {
      background-color: #c9c9c9;
    }
  }
  .prev {
    left: 190px;
  }
  .next {
    right: 190px;
  }
}
</style>